export const defaultSga = () => {
    return {
        codigos: [],
        idioma: ''
    }
}

export const defaultFrases = () => {
    return {
        frasesh: null,
        frasesp: null,
        edicion: ""
    }
}

export const defaultMedidas = () => {
    return {
        medidah: [
            4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19
        ],
        medidap: [
            4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19
        ],
        medidah4x6: 6,
        medidap4x6: 6,
        medidah7x10: 7,
        medidap7x10: 7,
        medidah18x10: 9,
        medidap18x10: 9,
        medidah21x18: 14,
        medidap21x18: 14,
        medidasesp: [],
    }
}

export const tiposEtiquetas = () => {
    return {
        tipos: [
            { text: 'Codigo', value: '0' },
            { text: '*', value: '1' },
            { text: 'Sin separador', value: '2' },
            { text: 'Enter', value: '3' },
            { text: '-', value: '4' }
        ]
    }
}


export const pictos = () => {
    return {
        Homologacion: [],
        Clasificacion: []
    }
}

export default {
    selectedSgaEt: defaultSga(),
    jsonSga: [],
    fisicos: [],
    salud: [],
    ambiental: [],
    peligrosas: [],
    Medidas: defaultMedidas(),
    FrasesEt: defaultFrases(),
    versiones: [6],
    pictogramas_et: pictos(),
    version: 6,
    tipo: 0,
    tipos: tiposEtiquetas(),
    filtro: {
        empresa: ""
    },
    categorias: [],
    codigosRepetidos: []

}